import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconExclamationMarkTriangle16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconExclamationMarkTriangle16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.76 2.716c-.754-1.403-2.766-1.403-3.521 0L1.75 11.052C1.033 12.384 1.998 14 3.511 14h8.977c1.514 0 2.479-1.616 1.761-2.948zm-2.64.474a1 1 0 0 1 1.76 0l4.489 8.336a1 1 0 0 1-.88 1.474H3.51a1 1 0 0 1-.88-1.474zM7.5 9V6a.5.5 0 0 1 1 0v3a.5.5 0 1 1-1 0m1.25 2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconExclamationMarkTriangle16);
